import { render } from "./MeasureDefinitionMetadataCard.vue?vue&type=template&id=130cafed&scoped=true&ts=true"
import script from "./MeasureDefinitionMetadataCard.vue?vue&type=script&lang=ts"
export * from "./MeasureDefinitionMetadataCard.vue?vue&type=script&lang=ts"

import "./MeasureDefinitionMetadataCard.vue?vue&type=style&index=0&id=130cafed&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130cafed"]])

export default __exports__